import axios from 'axios';
import authHeader from "@/service/auth-header";

class FinancialAccountService {

    getCompanyFinancialAccounts(companyId) {
        console.log("[FinancialAccountService][getCompanyFinancialAccounts] Before getting financial accounts. Company ID = ", companyId);
        return axios.get(`/api/financialaccount/${companyId}`, {headers: authHeader()})
    }

    createFinancialAccount(userId, data) {
        console.log("[FinancialAccountService][createFinancialAccount] Before creating financial account back-end API call. Data = ", data);
        return axios.post(`/api/financialaccount/${userId}`, data, {headers: authHeader()});
    }

    updateFinancialAccount(financialAccountId, data) {
        console.log("[FinancialAccountService][updateFinancialAccount] Before updating financial account back-end API call. Data = ", data);
        return axios.put(`/api/financialaccount/${financialAccountId}`, data, {headers: authHeader()});
    }

    deleteFinancialAccount(financialAccountId) {
        console.log("[FinancialAccountService][deleteFinancialAccount] Before deleting financial account. FinancialAccount ID = ", financialAccountId);
        return axios.delete(`/api/financialaccount/${financialAccountId}`, {headers: authHeader()});
    }

    createDefaultFinancialAccounts(companyId) {
        console.log("[FinancialAccountService][createDefaultFinancialAccounts] Before creating " +
            "default financial accounts. companyId = ", companyId);
        return axios.post(`/api/financialaccount/${companyId}/default`, null, {headers: authHeader()});
    }

}

export default new FinancialAccountService();
